import styled from 'styled-components'

interface ISpendVarianceStyledProps {}

export const SpendVarianceStyled = styled.div<ISpendVarianceStyledProps>`
  display: inline-flex;
  font-size: 1em;
  gap: ${(props) => props.theme.typography.pxToRem(8)};
`
